(function() {
  var options, quantity;
  document.addEventListener('htmx:beforeRequest', function(evt) {
    options = Flickity.data('.Product__Slideshow.Carousel.flickity-enabled').options;
    quantity = $('.ProductForm__QuantitySelector input').val();
  });
  
  document.addEventListener('htmx:afterRequest', function(evt) {
      var slider = new Flickity('.Product__Slideshow.Carousel', options);

      $('.Product__SlideshowNavScroller .Product__SlideshowNavImage').click(function(e){
       e.preventDefault();
       $('.Product__SlideshowNavScroller .Product__SlideshowNavImage').removeClass('is-selected');
  
       slider.select($('#Media' + this.getAttribute('data-media-id')).data('image-media-position'));
      });

      $('.ProductForm__QuantitySelector input').val(quantity);
      $('.ProductForm__QuantitySelector [data-action="decrease-quantity"]').click(function() {
        if ($('.ProductForm__QuantitySelector input').val() > 1)
          $('.ProductForm__QuantitySelector input').val(parseInt($('.ProductForm__QuantitySelector input').val()) - 1);
      });
      $('.ProductForm__QuantitySelector [data-action="increase-quantity"]').click(function() {
        $('.ProductForm__QuantitySelector input').val(parseInt($('.ProductForm__QuantitySelector input').val()) + 1);
      })

      $(window).resize();
  });

  let slider;
  window.onresize = function () {
       if (matchMedia('(min-width:768px)').matches) {
         slider?.destroy();
       } else {
         slider = new Flickity('.cw-color-swatches-slider', {
           contain: true,
           pageDots: false,
           prevNextButtons: false,
           draggable: true
         });
       }
  };
 document.addEventListener('DOMContentLoaded', function() {
   $(window).resize();
 });
})();